import translations, { supportedLanguages } from './translations';
import language from '../utils/browserLanguage';

const translate = (key, variables) => {
	const useLanguage = supportedLanguages.indexOf(language) !== -1 ? language : 'EN';

	try {
		let translation = translations[key][useLanguage];
		if (translation) {
			if (variables) {
				const keys = Object.keys(variables);
				for (let i = 0; i < keys.length; i++) {
					const k = keys[i];
					const value = variables[k];
					translation = translation.replace('##' + k + '##', value);
				}
			}
			return translation;
		}
	} catch (err) {
		console.log('Translation for key ' + key + ' and language ' + language + ' not found'); // eslint-disable-line  no-console
	}

	return '##' + key + '##';
};

export default translate;



// WEBPACK FOOTER //
// ./src/locale/translate.js